import PropTypes from 'prop-types';
import React from 'react';
import NoSSR from 'react-no-ssr';
import Pixel, {
    EmitMetric,
} from '../../../components/Analytics/VisibilityPixel/VisibilityPixel';
import { buildImagePath } from '../../Content/User/UserDisplay/UserImage/UserImage';
import './VirtualCareerFairCTA.scss';

export default class VirtualCareerFairCTA extends React.PureComponent {
    static propTypes = {
        /**
         * CTA Data
         * */
        cta: PropTypes.shape({
            src: PropTypes.string,
            mobileSrc: PropTypes.string,
            alt: PropTypes.string,
            url: PropTypes.string,
        }),
        metrics: PropTypes.object,
    };

    static defaultProps = {
        cta: {
            src: 'v1550664493/jobLanding/VCF_032619_desktop.png',
            mobileSrc: 'v1550664493/jobLanding/VCF_032619_mobile.png',
            alt:
                'Exclusive jobs event - Tuesday, March 26, 2019 - Virtual Career Fair for Women in Tech - On March 26, Fairygodboss is partnering with 20+ companies including IBM, Boston Scientific, Wells Fargo, 3M, and Asana for an all day virtual career fair. Register now to connect with companies looking to hire technical talent, like you! Register now!',
            url:
                'https://fairygodboss.vfairs.com/en/registration?partnerref=FGBJobsPageAD',
        },
        metrics: {
            clickTrigger: 'vcf_job_ad_clicked',
            impression: 'vcf_job_homepage_ad',
        },
    };

    getImagePaths = (imageSrc, size) => {
        const ctaInjectedPaths = {
            desktop: 'c_scale,f_auto,q_auto,w_500',
            mobile: 'c_scale,f_auto,q_auto,w_300',
        };
        return buildImagePath(imageSrc, size, ctaInjectedPaths);
    };

    render() {
        return (
            <NoSSR>
                <div className="component-JobV3-VirtualCareerFairCTA">
                    <a
                        href={this.props.cta.url}
                        target="_blank"
                        onClick={() => {
                            EmitMetric({
                                misc_event_type: this.props.metrics
                                    .clickTrigger,
                                misc_event_count: 1,
                            });
                        }}
                    >
                        <img
                            className="desktop"
                            src={this.getImagePaths(
                                this.props.cta.src,
                                'desktop'
                            )}
                            alt={this.props.cta.alt}
                            title={this.props.cta.alt}
                        />
                        <img
                            className="mobile"
                            src={this.getImagePaths(
                                this.props.cta.mobileSrc,
                                'mobile'
                            )}
                            alt={this.props.cta.alt}
                            title={this.props.cta.alt}
                        />
                    </a>
                    <Pixel
                        metrics={{
                            misc_event_type: this.props.metrics
                                .misc_event_count,
                            misc_event_count: 1,
                        }}
                    />
                </div>
            </NoSSR>
        );
    }
}
